"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUpward = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowUpward = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M12.5 22h-1a.5.5 0 01-.5-.5V5.33L6.56 9.78a.5.5 0 01-.71 0l-.7-.71a.5.5 0 010-.71l6.13-6.14a.75.75 0 01.53-.22h.38a.77.77 0 01.53.22l6.13 6.14a.5.5 0 010 .71l-.71.71a.49.49 0 01-.7 0L13 5.33V21.5a.5.5 0 01-.5.5z" })); };
exports.ArrowUpward = ArrowUpward;
//# sourceMappingURL=arrow-upward.js.map